var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeSolidIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.788 8a7.336 7.336 0 0 1 14.425 0A7.336 7.336 0 0 1 .788 8M8 11.333a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666M8 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
})));
export { SvgEyeSolidIcon as ReactComponent };
export default __webpack_public_path__ + "caa809818ffbdb7fc4ef3c4fba02c02c.svg";